import React from "react";


export default function ParentRegistration() {
  return (
    <div className="parentregister-container mt-4 p-4" style={{ background: "#f2f9ff", minHeight: "100vh" }}>
      <div className="text-center">
        <img
          src="/static/media/logo.25ae0241f5bf7d7c5384da9376d392bc.svg"
          alt="YellowCalf Logo"
          style={{ height: "60px" }}
        />

      </div>
        <hr className="divider" />
      <div className="bg-light border rounded p-4 mt-3 mx-auto" style={{ maxWidth: "900px" }}>
        <h5 className="mb-3">
          <i className="bi bi-person-plus"></i> Parent Registration
        </h5>

        <div className="row g-3">
          <div className="col-md-6">
            <label>First Name <span className="text-danger">*</span></label>
            <input className="form-control" type="text" />
          </div>
          <div className="col-md-6">
            <label>Last Name <span className="text-danger">*</span></label>
            <input className="form-control" type="text" />
          </div>

          <div className="col-md-6">
            <label>Email <span className="text-danger">*</span></label>
            <input className="form-control" type="email" />
          </div>
          <div className="col-md-6">
            <label>Nationality</label>
            <select className="form-select">
              <option>India</option>
              <option>USA</option>
              <option>UK</option>
            </select>
          </div>

          <div className="col-md-6">
            <label>Password <span className="text-danger">*</span></label>
            <input className="form-control" type="password" />
          </div>
          <div className="col-md-6">
            <label>Confirm Password <span className="text-danger">*</span></label>
            <input className="form-control" type="password" />
          </div>

          <div className="col-md-6">
            <label>Gender</label>
            <select className="form-select">
              <option>Select</option>
              <option>Male</option>
              <option>Female</option>
            </select>
          </div>
          <div className="col-md-6">
            <label>Date of Birth</label>
            <input className="form-control" type="date" />
          </div>

          <div className="col-md-6">
            <label>Address</label>
            <textarea className="form-control"></textarea>
          </div>
          <div className="col-md-6">
            <label>City</label>
            <input className="form-control" type="text" />
          </div>

          <div className="col-md-6">
            <label>Profile Picture</label>
            <input className="form-control" type="file" />
          </div>
          <div className="col-md-6">
            <label>Contact Number <span className="text-danger">*</span></label>
            <div className="input-group">
              <span className="input-group-text">+91</span>
              <input className="form-control" type="text" />
            </div>
          </div>

          <div className="col-md-6">
            <label>Captcha <span className="text-danger">*</span></label>
            <div className="d-flex gap-2 align-items-center">
              <img
                src=""
                alt="captcha"
                style={{ borderRadius: "4px" }}
              />
              <input className="form-control" placeholder="Verify Code" />
            </div>
          </div>
        </div>
        <hr className="dashed-line-divider" />

        <div className="d-flex justify-content-between mt-4">
          <button className="btn custom-btn">
            <i className="bi bi-arrow-left"></i> Back to Login
          </button>
          <button className="btn custom-btn">
            Submit Details <i className="bi bi-arrow-right-circle"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
